export const commonBrands = [
  "Audi",
  "BMW",
  "Citroen",
  "Dacia",
  "Fiat",
  "Ford",
  "Honda",
  "Hyundai",
  "Kia",
  "Mercedes",
  "Nissan",
  "Opel",
  "Peugeot",
  "Renault",
  "Seat",
  "Skoda",
  "Toyota",
  "Volkswagen",
  "Volvo",
];

// Liste des couleurs communes pour la sélection
export const commonColors = [
  "Blanc",
  "Noir",
  "Gris",
  "Rouge",
  "Bleu",
  "Vert",
  "Jaune",
  "Orange",
  "Marron",
  "Argent",
];

// Color mapping for the French color names to their corresponding HEX values
export const colorMap = {
  Blanc: "#FFFFFF",
  Noir: "#000000",
  Gris: "#808080",
  Rouge: "#FF0000",
  Bleu: "#0000FF",
  Vert: "#008000",
  Jaune: "#FFFF00",
  Orange: "#FFA500",
  Marron: "#8B4513",
  Argent: "#C0C0C0",
};
